const tabs = {
  "challenge-editor.tabs.info": "Información",
  "challenge-editor.tabs.media": "Medios",
  "challenge-editor.tabs.scenarios": "Escenarios",
  "challenge-editor.tabs.targets": "Objetivos",
};

const buttons = {
  "challenge-editor.buttons.validate-json": "VALIDAR JSON",
};

const dialog = {
  "challenge-editor.dialog.validation-errors.title": "Errores de validación",
  "challenge-editor.dialog.validation-errors.message": "Hay errores de validación en ({{field}}). Por favor, corríjalos antes de continuar.",
};

export const challengeEditor = {
  ...tabs,
  ...buttons,
  ...dialog,
}; 